import { useStaticQuery, graphql } from "gatsby";
import React from "react";

const Seo = ({ title, description }) => {
  const { site } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
        }
      }
    }
  `);
  const metaTitle = title || site.siteMetadata.title;
  const metaDescription = site.siteMetadata.description;
  // ignore config file desc for now - || site.siteMetadata.description;
  // as SEO report says description is needed, had to use the last solution above
  const metaImage = site.siteMetadata.siteUrl + site.siteMetadata.image;

  return (
    <>
      <title>{`${site.siteMetadata.title} | ${title} `}</title>
      <meta name="description" content={metaDescription} />
      <meta name="og:title" content={metaTitle} />
      <meta name="og:description" content={metaDescription} />
      <meta name="og:type" content="website" />
      <meta name="og:image" content={metaImage} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="manifest" href="/manifest.json" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0,user-scalable=1" />
      <script>
        {`
          function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
          }
        `}
      </script>
      {/* Start of HubSpot Embed Code */}
      {/*<script*/}
      {/*  type="text/javascript"*/}
      {/*  id="hs-script-loader"*/}
      {/*  async*/}
      {/*  defer*/}
      {/*  src="//js.hs-scripts.com/23846878.js"*/}
      {/*></script>*/}
      {/*Commented to make sure it can be easily backed-up within a minute*/}
      {/* End of HubSpot Embed Code */}
      {/* Google Tag Manager */}
      <script>
        {`(function(w,d,s,l,i){
          var cookie = getCookie('gatsby-gdpr-google-analytics');
          if(cookie !== 'true'){ return; }
          w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-PDVNWJ2Z');`}
      </script>
      {/*Google Analytics*/}
      <script async src="https://www.googletagmanager.com/gtag/js?id=GT-NSSVH2SK"></script>
      <script>
        {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'GT-NSSVH2SK');`}
      </script>
      {/* End Google Tag Manager */}
      {/* IrwinIQ Tag Manager */}
      <script>
        {`(function(w,d){
            var cookie = getCookie('gatsby-gdpr-google-analytics');
            if(cookie !== 'true'){ return; }
            var _mtm = w._mtm = w._mtm || [];
            _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
            var g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src='https://analytics.imirwin.com/js/container_J3ZAYf2a.js'; s.parentNode.insertBefore(g,s);
          })(window, document);`}
      </script>
      {/* End IrwinIQ Tag Manager */}
      {/* Hotjar Tracking Code for GMIN.Gold */}
      <script>
        {`(function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:5290426,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
      </script>
    </>
  );
};

export default Seo;
